import React  from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faFolderOpen } from '@fortawesome/free-solid-svg-icons'


export default function VacancyMenu( { showText = false , stop = null ,  centerTable , isAdd = false} ) {

  // function setClose()
  // {
  //   closeTable() ;

  // }

  function setCenterTable(  )
  {
      if ( isAdd === true )
      {
        console.log( "Llamando a vacancy add") ;
        centerTable( "VacancyAdd") ;
      }
      else{
        centerTable( "Vacancy") ;
      }

      

      if( stop !== null )
      {
        stop(true) ;
      }
      
  }


  return (
    <div>
        <div className=' drop-item' onClick={setCenterTable}>
          <FontAwesomeIcon   icon={faFolderOpen} title='Vacancy' style={{color:'white' , height:25 , display:'inline'}}/>
          { showText  &&    (  <p style={{display:'inline'}}>  &nbsp; &nbsp;Add Vacancy</p> ) }
        </div>
    </div>
  )
}